import Swiper from 'swiper';

class Bulider{
    constructor(){
        this.post_slider = document.querySelector('.sections_posts') ? document.querySelectorAll('.sections_posts') : '';
        this.banner = document.querySelector('.hero_big') ? document.querySelectorAll('.hero_big') : '';
        !this.post_slider || this.post_slider.forEach(element => this.swiperPost(element));
        !this.banner || this.banner.forEach(el => this.hero(el));
    }
    hero(el){
        !el.querySelector('a') || el.querySelector('a').addEventListener('click', e => {
            e.preventDefault();
            // window.scroll({
            //     behavior: 'smooth',
            //     left: 0,
            //     top: el.nextSibling
            // });
            el.nextSibling.scrollIntoView({
                behavior: 'smooth'
            });
            
            
        })
    }

    swiperPost(el){
        new Swiper(el.querySelector(".mySwiper"), {
            slidesPerView: "auto",
            spaceBetween: 30,
            centeredSlides: true,
            navigation: {
                prevEl: el.querySelector('.arrow-left'),
                nextEl: el.querySelector('.arrow-right'),
            },
        });
    }
}
export default Bulider;